export async function userInfoRequest(api) {
  const { data: data } = await api.get(`user-info`);
  return { data };
}
export async function profileRequest(api) {
  const { data: data } = await api.get(`profile`);
  return { data };
}

export async function profileReligion(api) {
  const { data: data } = await api.get(`profile-religions`);
  return { data };
}

export async function profileNationality(api) {
  const { data: data } = await api.get(`profile-nationalities`);
  return { data };
}

export async function profileCountry(api) {
  const { data: data } = await api.get(`profile-countries`);
  return { data };
}

export async function updatePassword(api, newPass) {
  const { data: data } = await api.post(`profile/updateUserPassword`, newPass);
  return { data };
}

export async function uploadAvatarImage(api, image) {
  const { data: data } = await api.post(`avatar/upload`, image);
  return { data };
}

export async function firstPasswordChange(api, formData) {
  const { data: data } = await api.post(`first-password-change`, formData);
  return { data };
}
